import application_settings from '../applicationSettings';
import Event from './Event';

class GetLoyaltyPoints extends Event {
    eventName = 'oms_getLoyaltyPoints';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get loyalty points
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // request data
        data.endPoint = application_settings.endPoints.getLoyaltyPoints;
        data.canUsePublicAuth = false;

        data.data = {
            client_id: data.client_id,
            order_currency: data.order_currency,
        };

        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });

    }
}

export default GetLoyaltyPoints;